import { render, staticRenderFns } from "./WebsiteClientSlider.vue?vue&type=template&id=31fcf13b&scoped=true&"
import script from "./WebsiteClientSlider.vue?vue&type=script&lang=js&"
export * from "./WebsiteClientSlider.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteClientSlider.vue?vue&type=style&index=0&id=31fcf13b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fcf13b",
  null
  
)

export default component.exports